import { Reveal } from "./Reveal";

const PILLARS = [
  ["I", "Rooted", "in tradition.", "The velvet, the gold, the cape that crowned clergy and kings."],
  ["II", "Reimagined", "for royalty.", "Cut and cropped for galas, weddings, brunch and the street."],
  ["III", "Worn", "with pride.", "For the woman who honors where she comes from — loudly."],
];

export const Pillars = () => (
  <section data-testid="pillars-section" className="border-y border-gold/15 bg-ink2 py-28 lg:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-10">
      {PILLARS.map(([n, a, b, text], i) => (
        <Reveal key={n} delay={i * 0.05}>
          <div className="group grid items-baseline gap-4 border-b border-gold/15 py-10 md:grid-cols-[80px_1fr_320px] md:gap-10" data-testid={`pillar-${i + 1}`}>
            <span className="font-mono text-xs tracking-[0.3em] text-gold">{n}</span>
            <p className="font-display text-5xl font-light leading-none tracking-tight text-cream transition-transform duration-700 ease-out group-hover:translate-x-3 sm:text-7xl lg:text-8xl">
              {a} <span className="italic text-white">{b}</span>
            </p>
            <p className="text-sm font-light leading-relaxed text-stone2 sm:text-base">{text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
